import { useQualityComplaintsService } from '@/views/Quality/services/qualityComplaintsService'

export function createQualityComplaintsActions(state) {
    const service = useQualityComplaintsService()

    const fetchComplaints = async (queryString = '') => {
        try {
            return await service.fetchComplaints(queryString)
        } catch (error) {
            throw error
        }
    }

    const fetchComplaintById = async (id) => {
        try {
            return await service.fetchComplaint(id)
        } catch (error) {
            throw error
        }
    }

    const prefetchComplaint = async (id) => {
        try {
            const response = await service.fetchComplaint(id)
            state.prefetchedComplaint.value = response?.data || null
            return response
        } catch (error) {
            state.prefetchedComplaint.value = null
            throw error
        }
    }

    const clearPrefetchedComplaint = () => {
        state.prefetchedComplaint.value = null
    }
    const downloadComplaintCard = async (complaintId) => {
        try {
            return await service.downloadComplaintCard(complaintId)
        } catch (error) {
            throw error
        }
    }

    const fetchComplaintStatusHistory = async (id) => {
        try {
            return await service.fetchComplaintStatusHistory(id)
        } catch (error) {
            throw error
        }
    }

    const deleteComplaint = async (id) => {
        try {
            return await service.deleteComplaint(id)
        } catch (error) {
            throw error
        }
    }

    const createComplaint = async (payload) => {
        try {
            return await service.createComplaint(payload)
        } catch (error) {
            throw error
        }
    }

    const updateComplaint = async (payload) => {
        try {
            return await service.updateComplaint(payload)
        } catch (error) {
            throw error
        }
    }

    const generateComplaintsReport = async (queryString = '', userEmail) => {
        try {
            return await service.generateComplaintsReport(queryString, userEmail)
        } catch (error) {
            throw error
        }
    }

    const fetchComplaintTypes = async () => {
        try {
            const response = await service.fetchComplaintTypes()
            const data = response?.data
            state.complaintTypes.value = Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : []
            return response
        } catch (error) {
            throw error
        }
    }

    const fetchComplaintStatuses = async () => {
        try {
            const response = await service.fetchComplaintStatuses()
            const data = response?.data
            state.complaintStatuses.value = Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : []
            return response
        } catch (error) {
            throw error
        }
    }

    const fetchProductionDepartments = async (filter = null) => {
        try {
            const response = await service.fetchProductionDepartments(filter)
            const data = response?.data
            state.productionDepartments.value = Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : []
            return response
        } catch (error) {
            throw error
        }
    }

    const fetchJobNumbers = async (query) => {
        try {
            return await service.fetchJobNumbers(query)
        } catch (error) {
            throw error
        }
    }

    const fetchOrderNumbers = async (query) => {
        try {
            return await service.fetchOrderNumbers(query)
        } catch (error) {
            throw error
        }
    }

    const createAttachment = async (formData, config) => {
        try {
            return await service.createAttachment(formData, config)
        } catch (error) {
            throw error
        }
    }

    const deleteAttachment = async (id) => {
        try {
            return await service.deleteAttachment(id)
        } catch (error) {
            throw error
        }
    }

    return {
        fetchComplaints,
        fetchComplaintById,
        prefetchComplaint,
        clearPrefetchedComplaint,
        createComplaint,
        updateComplaint,
        generateComplaintsReport,
        fetchComplaintTypes,
        fetchComplaintStatuses,
        fetchProductionDepartments,
        fetchJobNumbers,
        fetchOrderNumbers,
        createAttachment,
        deleteAttachment,
        downloadComplaintCard,
        fetchComplaintStatusHistory,
        deleteComplaint
    }
}
